import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "proportion-scaler",
  title: "Proportion Scaler",
  description:
    "Scale dimensions proportionally, preserve aspect ratios, and copy resized width and height values.",
  category: "Other",
} satisfies ToolMeta;
